import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'gt-payment-response',
  templateUrl: './payment-response.page.html',
})
export class PaymentResponsePage {
  success = this.actRouter.snapshot.data['success'];

  constructor(private actRouter: ActivatedRoute) {}
}
